
import { PlusOutlined } from '@ant-design/icons';

import logo from '../image/logo.svg'

import Energy1 from '../image/Energy1-24x24.svg'
import Strength from '../image/Strength-24x24.svg'
import Endurance from '../image/Endurance-24x24.svg'
import OptimalLevels from '../image/Optimal-Levels-24x24.svg'
import Energy2 from '../image/Energy2-24x24.svg'
import Youthfulness from '../image/Youthfulness-26x26.svg'
import Resilience from '../image/Resilience-24x24.svg'
import GentlePower from '../image/Gentle-Power-24x24.svg'

import Energy_Black from '../image/Energy1-black-40x40.svg'
import Strength_Black from '../image/Strength-black-40x40.svg'
import Endurance_Black from '../image/Endurance-black-40x40.svg'
import OptimalLevels_Black from '../image/Optimal-levels-black-40x40.svg'



// dictLabel:"社区"  
// dictValue: "community"
const communityData = {
  cardList: [{
    type: 'card',
    star: 5,
    title: 'I feel like I have gotten younger',
    content: `I simply feel like I have more energy to do everything.  This is like a caffeine jolt without any of the side effects.  I am hoping these results continue and build on what is currently happening?  I'm willing to continue for a couple of months to find out.`,
    name: 'Kathryn C',
    productImg: require('../image/shop1-1200x1200.avif'),
    productName: 'Mitopure Softgels',
    link: '',
  },{
    type: 'card',
    star: 5,
    title: 'Great Addition to Skincare Routine!',
    content: `The night cream has been a great addition to my skincare routine.  I feel it has lightened my dark spots and made my skin less dull.  It feels indulgent but is still an affordable addition to my lotions and potions!`,
    name: 'Jolene M',
    productImg: require('../image/shop4-1200x1200.avif'),
    productName: 'The Night Cream',
    link: '',
  },{
    type: 'card',
    star: 5,
    title: 'Actually works!',
    content: `I grabbed the Time-Line Day Cream for my wife due to some uneven skin tone she was going through after having our daughter a year ago. She started a month ago, and we definitely saw the change! My wife's skin tone became smoother and clearer. Many of the blemishes and uneven skin tone had disappeared. This product is amazing!`,
    name: 'Nadim H',
    productImg: require('../image/shop2-1200x1200.avif'),
    productName: 'The Day Cream',
    link: '',
  },{
    type: 'card',
    star: 5,
    title: 'Wonderful',
    content: `This serum truly makes you look younger and feel confident. I felt like my wrinkles were fading and my skin felt tighter after just one week. I also look brighter and moisturized ! I recommend this serum to anyone looking for a little help looking bright and youthful!`,
    name: 'Marleise C',
    productImg: require('../image/shop5-1200x1200.avif'),
    productName: 'The Serum',
    link: '',
  }],
  videoList: [{
    type: 'video',
    cardType: 'doctor',

    img: require("../image/community-img.png"),
    video: "",
    name: 'Dr. Mark Hyman, MD',
    achievement: 'Functional Medicine Physician, 15x New York Times Bestselling Author'
  },{
    type: 'video',
    cardType: 'doctor',

    img: require("../image/community-img.png"),
    video: "",
    name: 'Dr. Gabrielle Lyon',
    achievement: 'Founder Institute for Muscle-Centric Medicine®'
  },{
    type: 'video',
    cardType: 'userComment',

    img: require("../image/community-img.png"),
    video: "",
    name: 'idodeclaire2013',
    productImg: require('../image/shop1-1200x1200.avif'),
    productName: 'Mitopure Softgels',
  },{
    type: 'video',
    cardType: 'userComment',

    img: require("../image/community-img.png"),
    video: "",
    name: 'chrisellelim',
    productImg: require('../image/shop5-1200x1200.avif'),
    productName: 'The Serum',
  }]
}

// dictLabel:"自动切换卡片"   
// dictValue: "auto_switching"
let AutoSwitchingData = {
  title: 'Hear from thought leaders',
  data: [{
    img: require('../image/expert1.avif'),
    name: 'Dr. Casey Means, MD',
    identity: 'Physician, author & health tech entrepreneur',
    sentence: 'Improving the quality of our mitochondria helps us live healthier and longer lives. '
  },{
    img: require('../image/expert2.avif'),
    name: 'Dr. Mark Hyman, MD',
    identity: 'Functional Medicine Physician, 15x New York Times Bestselling Author',
    sentence: 'This is a supplement I use myself everyday to be as healthy as I can, for as long as I can.'
  },{
    img: require('../image/expert3.avif'),
    name: 'Dr. Gabrielle Lyon',
    identity: 'Founder Institute for Muscle-Centric Medicine®',
    sentence: 'No other supplement does what Timeline can. It is an amazing advance for muscle health and longevity.'
  },{
    img: require('../image/expert4.avif'),
    name: 'Dr. Johan Auwerx MD, PhD',
    identity: 'Scientific Advisor',
    sentence: 'The latest clinical study really crystallizes how Mitopure can be a real game-changer for human health.'
  },{
    img: require('../image/expert5.avif'),
    name: 'Eric Verdin, MD',
    identity: 'CEO Buck Institute for Research on Aging, Scientific Advisor',
    sentence: 'Mitochondrial decline is a key hallmark of aging and Mitopure is one of the most promising compounds in our field'
  }]
}


// dictLabel:"推荐商品"   
// dictValue: recommend_goods
let recommend_goodsData = {
  title: 'Mitopure Softgels',
  description: 'Improve your cellular health by taking Mitopure in its simplest form with two vegan softgels daily for the recommended dose of Urolithin A (500mg of Mitopure). Each sachet contains 60 softgels, which will last you a month.',
  img: require('../image/shop1-1200x1200.avif'),
  // star: 4.4,
  // commentCount: 2813,
  bestseller: false,
  tag: false
}

// dictLabel:"轮播 - 商品"   
// dictValue:"carousel_goods"
let goodsCarouselData = {
  CarouselText: '由 Mito Labs(HK) 提供技术支持的产品',
  btnText: '探索我们的科学',
  link: '/shop',
  data: []
}



// dictLabel:"轮播 - 关于"   
// dictValue:"carousel_article"
let articleCarouselData = {
  CarouselText: '最新消息',
  btnText: '前往',
  link: '',
  data: []
}

// dictLabel:"图片在左侧的卡片"   &&    dictLabel:"图片在右侧的卡片" 
// dictValue:"card_img_left" && dictValue:"card_img_right"
let imgCardData = {
  // type: 'imgCard',
  bgImg: require('../image/bigCardBg1-1600x2000.png'),
  textWidth: '40%',
  // textPosition: 'left',
  // textAlignItem: 'center',
  title: 'Mitopure®, the nutrient that can re‑energize cells',
  titleSize: 'clamp(40px, calc(31.55px + 2.25vw), 64px)',
  spacing: 30,
  description: 'As we age, our cells age. Mitopure® is the first postbiotic nutrient shown to trigger a crucial recycling process within our cells called mitophagy, targeting age-related cellular decline*.',
  descriptionSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
  descriptionColor: 'rgba(0,0,0,0.54)',
  btnConfig:{
    text: 'Learn more',
    link: ''
  }
}

// dictLabel:"图片在左侧，右侧内容含小卡片"   &&    dictLabel:"图片在右侧，左侧内容含小卡片"  
// dictValue:"card_img_left_icon" && dictValue:"card_img_right_icon"
let imgCardData_icon = {
  // type: 'imgCard',
  bgImg: require('../image/bigCardBg1-1600x2000.png'),
  textWidth: '45%',
  // textPosition: 'right',
  // textAlignItem: 'top',
  title: 'The proven benefits of energized cells',
  titleSize: 'clamp(32px, calc(27.07px + 1.31vw), 46px)',
  spacing: 20,
  description: 'Our scientists continuously conduct thorough clinical studies to prove the incredible impact of Mitopure® on human cells and reveal its full potential.',
  descriptionSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
  descriptionColor: '#272724',
  childDom: [{
    type: 'icon',
    content: {
      top: <img style={{width: 40}} src={Energy_Black} alt="" />,
      divider: true,
      title: 'Energy',
      titleSize: 'clamp(22px, calc(19.89px + 0.56vw), 28px)',
      description: 'In collaboration with the Swiss Federal Institute of Technology de Lausanne (EPFL)',
      descriptionSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
    },
    btnConfig: {
      icon: 'PlusOutlined',
      link: ''
    }
  },{
    type: 'icon',
    content: {
      top: <img style={{width: 40}} src={Strength_Black} alt="" />,
      divider: true,
      title: 'Strength',
      titleSize: 'clamp(22px, calc(19.89px + 0.56vw), 28px)',
      description: 'In collaboration with the Swiss Federal Institute of Technology de Lausanne (EPFL)',
      descriptionSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
    },
    btnConfig: {
      icon: 'PlusOutlined',
      link: ''
    }
  },{
    type: 'icon',
    content: {
      top: <img style={{width: 40}} src={Endurance_Black} alt="" />,
      divider: true,
      title: 'Endurance',
      titleSize: 'clamp(22px, calc(19.89px + 0.56vw), 28px)',
      description: 'In collaboration with the Swiss Federal Institute of Technology de Lausanne (EPFL)',
      descriptionSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
    },
    btnConfig: {
      icon: 'PlusOutlined',
      link: ''
    }
  },{
    type: 'icon',
    content: {
      top: <img style={{width: 40}} src={OptimalLevels_Black} alt="" />,
      divider: true,
      title: 'Optimal levels',
      titleSize: 'clamp(22px, calc(19.89px + 0.56vw), 28px)',
      description: 'In collaboration with the Swiss Federal Institute of Technology de Lausanne (EPFL)',
      descriptionSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
    },
    btnConfig: {
      icon: 'PlusOutlined',
      link: ''
    }
  }],
  btnConfig:{
    text: 'Learn more',
    link: ''
  }
}

// dictLabel:"带背景图片的卡片，内容在左侧"   &&    dictLabel:"带背景图片的卡片，内容在右侧"  
// dictValue:"card_bg_leftContent" && dictValue:"card_bg_rightContent"
let bgCardData = {
  // type: 'bgCard',
  bgImg: require('../image/bigCardBg2-2640x1200.png'),
  textWidth: '30%',
  // textPosition: 'right',
  title: 'Meet Urolithin A, a rare molecule that renews our cellular powerhouses',
  description: 'Our scientists unlocked the power of Urolithin A, a molecule that stimulates this crucial recycling and cleansing process - ultimately protecting cells from age-associated decline..',
  btnConfig:{
    text: 'Scientific research',
    icon: 'PlusCircleOutlined',
    link: ''
  }
}


// dictLabel:"含有2张图片模块，呈两列分布"   
// dictValue:"model_dbImg"
let dbCard = {
  // type: 'dbCard',
  title: 'Skin aging is caused by two types of factors',
  description: 'Intrinsic and extrinsic factors lead to visible signs of skin aging such as the appearance of wrinkles, hyperpigmentation, sagginess and a loss of radiance. They also weaken the skin structure by making it thinner and drier, compromising its ability to remain healthy and youthful in the long-term.',
  list:[{
    img: require('../image/db-card-img-1.avif'),
    title: 'Foods (e.g Pomegranates)',
    childList: [{
      title: 'Uncertain',
      description: 'Not everyone can naturally produce Urolithin A. Our clinical study revealed that 60% of us don’t have the right gut bacteria to convert food into Urolithin A.',
      link: ''
    },{
      title: 'Uncertain',
      description: 'Not everyone can naturally produce Urolithin A. Our clinical study revealed that 60% of us don’t have the right gut bacteria to convert food into Urolithin A.',
      link: ''
    }]
  },{
    img: require('../image/db-card-img-2.avif'),
    title: 'Mitopure®',
    childList: [{
      title: 'Uncertain',
      description: 'Not everyone can naturally produce Urolithin A. Our clinical study revealed that 60% of us don’t have the right gut bacteria to convert food into Urolithin A.',
      link: ''
    },{
      title: 'Uncertain',
      description: 'Not everyone can naturally produce Urolithin A. Our clinical study revealed that 60% of us don’t have the right gut bacteria to convert food into Urolithin A.',
      link: ''
    }]
  }]
}


// dictLabel:"含有两张图片的模块，左侧展示内容"   
// dictValue:"model_dbImg_leftContent"
let dbImg_leftContent_CardList = {
  // type: 'goodCard', 
  textWidth: '30%',
  title: 'Cellular health changes everything',
  description: 'Mitopure® (Urolithin A), is one of, if not, the most clinically studied compound in longevity science. This postbiotic targets age-related decline at its source: your cells. And the benefits are impressive. Founded by MDs and PhDs and backed by 15+ years of research.',
  cardList:[{
    type: 'img',
    content: {
      title: '对身体的益处',
      img: <img src={require('../image/sticky-img.webp')} style={{width: '100%',borderRadius:5}}/>,
      list: [
        {name: 'Energy',icon: Energy1},
        {name: 'Strength',icon: Strength},
        {name: 'Endurance',icon: Endurance},
        {name: 'Optimal Levels',icon: OptimalLevels}
      ],
    },
    btnConfig: {
      icon: 'ArrowRightOutlined',
      link: '/science'
    }
  },{
    type: 'img',
    content: {
      title: '前往科学',
      img: <img src={require('../image/bigCardBg2-1200x964.png')} style={{width: '100%',borderRadius:5}}/>,
      list: [
        {name: 'Energy',icon: Energy2},
        {name: 'Youthfulness',icon: Youthfulness},
        {name: 'Resilience',icon: Resilience},
        {name: 'Gentle power',icon: GentlePower}
      ],
    },
    btnConfig: {
      icon: 'ArrowRightOutlined',
      link: '/science'
    }
  }]
}

// dictLabel:"照片墙"   &&    dictLabel:"照片墙，带抽屉"  
// dictValue:"photo_wall" && dictValue:"photo_wall_drawer"
let PhotoWallData = {
  // drawer: false,
  title: 'Scientists, Doctors, Longevity Experts',
  titleSize: 'clamp(32px, calc(27.07px + 1.31vw), 46px)',
  subTitle: 'Recommended by',
  subTitleSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
  subTitle2: '',
  description: '',
  descriptionSize: '',
  data: [{
    type: 'icon',
    content: {
      top: <img src={require('../image/expert4.avif')} style={{width:'100%'}} alt="" />,
      divider: false,
      title: 'Dr. Johan Auwerx MD, PhD',
      titleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      subTitle: 'Scientific Advisor',
      subTitleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      description: 'Professor. Johan Auwerx directs the Laboratory for Integrated and Systems Physiology at École Polytechnique Fédérale (EPFL) in Lausanne, Switzerland, where he studies the mechanisms that control how metabolisms are controlled and the factors that make them more or less effective. Focusing on longevity, his team is using multiple animal species to test a specific compound, Urolithin A, which could potentially restore much-needed muscle strength and energy to people as they age. Prof. Auwerx is a scientific advisor to Amazentis.',
      descriptionSize: 'clamp(12px, calc(11.65px + 0.09vw), 13px)',
    },
    btnConfig: null
  },{
    type: 'icon',
    content: {
      top: <img src={require('../image/expert4.avif')} style={{width:'100%'}} alt="" />,
      divider: false,
      title: 'Dr. Johan Auwerx MD, PhD',
      titleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      subTitle: 'Scientific Advisor',
      subTitleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      description: 'Professor. Johan Auwerx directs the Laboratory for Integrated and Systems Physiology at École Polytechnique Fédérale (EPFL) in Lausanne, Switzerland, where he studies the mechanisms that control how metabolisms are controlled and the factors that make them more or less effective. Focusing on longevity, his team is using multiple animal species to test a specific compound, Urolithin A, which could potentially restore much-needed muscle strength and energy to people as they age. Prof. Auwerx is a scientific advisor to Amazentis.',
      descriptionSize: 'clamp(12px, calc(11.65px + 0.09vw), 13px)',
    },
    btnConfig: null
  },{
    type: 'icon',
    content: {
      top: <img src={require('../image/expert4.avif')} style={{width:'100%'}} alt="" />,
      divider: false,
      title: 'Dr. Johan Auwerx MD, PhD',
      titleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      subTitle: 'Scientific Advisor',
      subTitleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      description: 'Professor. Johan Auwerx directs the Laboratory for Integrated and Systems Physiology at École Polytechnique Fédérale (EPFL) in Lausanne, Switzerland, where he studies the mechanisms that control how metabolisms are controlled and the factors that make them more or less effective. Focusing on longevity, his team is using multiple animal species to test a specific compound, Urolithin A, which could potentially restore much-needed muscle strength and energy to people as they age. Prof. Auwerx is a scientific advisor to Amazentis.',
      descriptionSize: 'clamp(12px, calc(11.65px + 0.09vw), 13px)',
    },
    btnConfig: null
  },{
    type: 'icon',
    content: {
      top: <img src={require('../image/expert4.avif')} style={{width:'100%'}} alt="" />,
      divider: false,
      title: 'Dr. Johan Auwerx MD, PhD',
      titleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      subTitle: 'Scientific Advisor',
      subTitleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      description: 'Professor. Johan Auwerx directs the Laboratory for Integrated and Systems Physiology at École Polytechnique Fédérale (EPFL) in Lausanne, Switzerland, where he studies the mechanisms that control how metabolisms are controlled and the factors that make them more or less effective. Focusing on longevity, his team is using multiple animal species to test a specific compound, Urolithin A, which could potentially restore much-needed muscle strength and energy to people as they age. Prof. Auwerx is a scientific advisor to Amazentis.',
      descriptionSize: 'clamp(12px, calc(11.65px + 0.09vw), 13px)',
    },
    btnConfig: null
  }]
}

// dictLabel:"产品描述模块"   
// dictValue:"model_description"
let productDescriptionData = {
  title: <div>
    多维度复合配方，协调增效|提升ATP产能效率|焕活线粒体，提升代谢效率，清除自由基|降低神经炎症|多彩胶囊，便携包设计，30日支持IGMP认证+SGS检测
  </div>,
  data: [{
    type: 'text',
    content: {
      top: '5+',
      title: '多症状改善',
      description: '极度疲劳、劳累后不适 (PEM) 、脑雾、肌肉酸痛无力、自主神经功能障碍、情绪低落、睡眠障碍',
    },
    btnConfig: false
  },{
    type: 'text',
    content: {
      top: '30',
      title: '每盒含量',
      description: '30日连续改善不适症状',
    },
    btnConfig: false
  },{
    type: 'text',
    content: {
      top: '-30%',
      title: 'ROS',
      description: '多重抗氧化，有效降低氧化应激水平',
    },
    btnConfig: {
      icon: 'PlusOutlined',
      link: ''
    }
  },{
    type: 'text',
    content: {
      top: '4',
      title: '-多维靶点',
      description: '从增结构稳态、提升ATP效能、降低氧化应激、清除衰老线粒体四个维度，激活线粒体',
    },
    btnConfig: {
      icon: 'ArrowRightOutlined',
      link: '/science'
    }
  }]
}


// dictLabel:"Q_A"   
// dictValue:"Q_A"
const genExtra = () => (
  <PlusOutlined
    onClick={(event) => {
      // If you don't want click extra trigger collapse, you can prevent this:
      console.log(123)
    }}
  />
);
const title = (
  <div style={{ fontSize: 'clamp(18px, calc(16.94px + 0.28vw), 21px)', color:'#000' }}>
    什么是HappyCell和Mitolabs(HK)？
  </div>
)
const text = (
  <p style={{ fontSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)', color:'#272724', margin: 0 }}>
    A dog is a type of domesticated animal. Known for its loyalty and faithfulness, it can be found
    as a welcome guest in many households across the world.
  </p>
);
const questionsData = [
  {
    key: '1',
    label: title,
    children: text,
    showArrow: false,
    extra: genExtra(),
  },
  {
    key: '2',
    label: title,
    children: text,
    showArrow: false,
    extra: genExtra(),
  },
  {
    key: '3',
    label: title,
    children: text,
    showArrow: false,
    extra: genExtra(),
  },
];



// dictLabel:"图片时间轴"   
// dictValue:"img_timeLine"
let ImgTimeLineData = {
  title: 'Your cells feel the benefits before you do',
  subTitle: 'Step into the journey of Mitopure and its transformative effects on your body. From the first hours to one year in, chart your course towards optimal health.',
  data: [{
    type: 'ImgTimeLine',
    content: {
      img: require('../image/ImgTimeLine-1776x1776.avif'),
      // img: <img src={require('../image/ImgTimeLine-1776x1776.avif')} style={{width: '100%',borderRadius:5}}/>,
      video: '',
      title: 'Hour 08',
      subTitle: 'Healthy aging nutrient gets absorbed',
      description: `You've just begun taking Mitopure and it's already springing into action. Urolithin A levels peak in your bloodstream, targeting key organs like your muscles.`,
    },
    btnConfig: {
      link: ''
    }
  },{
    type: 'ImgTimeLine',
    content: {
      img: require('../image/ImgTimeLine-1776x1776.avif'),
      // img: <img src={require('../image/ImgTimeLine-1776x1776.avif')} style={{width: '100%',borderRadius:5}}/>,
      video: '',
      title: 'Hour 08',
      subTitle: 'Healthy aging nutrient gets absorbed',
      description: `You've just begun taking Mitopure and it's already springing into action. Urolithin A levels peak in your bloodstream, targeting key organs like your muscles.`,
    },
    btnConfig: {
      link: ''
    }
  },{
    type: 'ImgTimeLine',
    content: {
      img: require('../image/ImgTimeLine-1776x1776.avif'),
      // img: <img src={require('../image/ImgTimeLine-1776x1776.avif')} style={{width: '100%',borderRadius:5}}/>,
      video: '',
      title: 'Hour 08',
      subTitle: 'Healthy aging nutrient gets absorbed',
      description: `You've just begun taking Mitopure and it's already springing into action. Urolithin A levels peak in your bloodstream, targeting key organs like your muscles.`,
    },
    btnConfig: {
      link: ''
    }
  },{
    type: 'ImgTimeLine',
    content: {
      img: require('../image/ImgTimeLine-1776x1776.avif'),
      // img: <img src={require('../image/ImgTimeLine-1776x1776.avif')} style={{width: '100%',borderRadius:5}}/>,
      video: '',
      title: 'Hour 08',
      subTitle: 'Healthy aging nutrient gets absorbed',
      description: `You've just begun taking Mitopure and it's already springing into action. Urolithin A levels peak in your bloodstream, targeting key organs like your muscles.`,
    },
    btnConfig: {
      link: ''
    }
  },{
    type: 'ImgTimeLine',
    content: {
      img: require('../image/ImgTimeLine-1776x1776.avif'),
      // img: <img src={require('../image/ImgTimeLine-1776x1776.avif')} style={{width: '100%',borderRadius:5}}/>,
      video: '',
      title: 'Hour 08',
      subTitle: 'Healthy aging nutrient gets absorbed',
      description: `You've just begun taking Mitopure and it's already springing into action. Urolithin A levels peak in your bloodstream, targeting key organs like your muscles.`,
    },
    btnConfig: {
      link: ''
    }
  },{
    type: 'ImgTimeLine',
    content: {
      img: require('../image/ImgTimeLine-1776x1776.avif'),
      // img: <img src={require('../image/ImgTimeLine-1776x1776.avif')} style={{width: '100%',borderRadius:5}}/>,
      video: '',
      title: 'Hour 08',
      subTitle: 'Healthy aging nutrient gets absorbed',
      description: `You've just begun taking Mitopure and it's already springing into action. Urolithin A levels peak in your bloodstream, targeting key organs like your muscles.`,
    },
    btnConfig: {
      link: ''
    }
  }]
}


export {
  communityData,
  AutoSwitchingData,
  recommend_goodsData,
  goodsCarouselData,
  articleCarouselData,
  imgCardData,
  imgCardData_icon,
  bgCardData,
  dbCard,
  dbImg_leftContent_CardList,
  PhotoWallData,
  productDescriptionData,
  questionsData,
  ImgTimeLineData,
}